import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { DataTable } from "@msuite/ui/table";
import { guardArray } from "@msuite/utils/array";
import { useCalculationMembers } from "@/hooks/use-calculation-members";
import { CalculationFormMembersMenu } from "./calculation-form-members-menu";
import { columns } from "./calculation-form-members-table-config";

/** Props Interface */
interface CalculationFormMembersProps {
	calculationId: string;
}

export function CalculationFormMembers({ calculationId }: CalculationFormMembersProps) {
	/** Hooks */
	const { t } = useTranslation();
	const { members, isLoading, queryKey, refetch } = useCalculationMembers(calculationId);

	/** Render */
	return (
		<div className="flex-1 h-full">
			<ContentCard
				title={t("organization.members")}
				icon={icon("Users")}
				variant="plain"
				className="h-full"
				contentClassName="h-full"
			>
				<DataTable
					data={members}
					columns={columns}
					persistenceKey="calculation-form-members-table"
					isLoading={isLoading}
					queryKey={queryKey}
					refetch={refetch}
					menu={
						<CalculationFormMembersMenu
							calculationId={calculationId}
							excludeUserIds={guardArray(members).map((member) => member.userId)}
							refetch={refetch}
						/>
					}
				/>
			</ContentCard>
		</div>
	);
}
